import * as amplitude from '@amplitude/analytics-browser'

export { amplitude }

export default amplitude
